import cx from 'classnames';
import * as React from 'react';

import './styles/ListItem.scss';

type Props = {
  children?: React.ReactNode;
  className?: string;
};

// If you're ever developing locally, and find that all your list items have
// nexted <li> items for no apparent reason, it seems to be due to some
// weirdness in how react-hot-loader interacts with
// https://github.com/remind101/r101-frontend/blob/f252c53cfa149d8b7af2ad365e4ef5498ec0f64d/src/components/List.tsx#L100-L109.
// This breaks the css of the GroupAvatarSelector component used in the class
// settings page.
//
// The good thing is this doesn't have any effect on staging/production, since
// they don't use react hot loader. The bad thing is that you might waste a lot
// of time debugging an issue that doesn't really exist. So if you ever see
// weird css breakages due to a <li> nested inside another <li> element in your
// local dev environment, canary your change in staging or prod. If you don't
// see the same issue there, it's just the hot loader issue and not a real bug,
// so you can ignore it.
//
// Reference to other discussion about this sort of weirdness with react hot
// loader: https://github.com/gaearon/react-hot-loader/issues/1311
export default function ListItem({ children, className, ...props }: Props) {
  return (
    <li {...props} className={cx('ListItem', className)}>
      {children}
    </li>
  );
}
